module.exports = __webpack_public_path__ + "img/liudahexin.b87a74da.png";